/**
 * `beforeinstallprompt` fires once, often immediately on page load — well
 * before React mounts. A listener attached inside a component's `useEffect`
 * (as `useInstallApp` used to do) can miss it entirely: Chrome falls back to
 * its own native install banner since nothing called `preventDefault()` in
 * time, and the app is left thinking the browser is "unsupported" even
 * though the user just saw Chrome's own "Install X?" prompt.
 *
 * This module is imported as the very first line of src/index.js, so its
 * listener is attached before anything else runs.
 */

let deferredEvent = null;
let installedFlag = false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredEvent = event;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    installedFlag = true;
    deferredEvent = null;
    notify();
  });
}

export const getDeferredEvent = () => deferredEvent;
export const clearDeferredEvent = () => {
  deferredEvent = null;
};
export const wasInstalledEventSeen = () => installedFlag;

/** Returns an unsubscribe function. */
export const subscribeInstallPrompt = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};
